import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
$.fn.serializeObject = function() {
    let form = this[0];

    let data = new FormData(form);
    let dataObject = {};

    for(let entry of data.entries()) {
        dataObject[entry[0]] = entry[1];
    }

    return dataObject;
}

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function setvw100() {
    document.documentElement.style.setProperty('--vw100', $(window).width() + 'px');
}

setvw100();
$(window).resize(() => {
    window.resizeTimeout ? clearTimeout(window.resizeTimeout) : '';
    window.resizeTimeout = setTimeout(() => {
        setvw100();
    }, 200)
});
